import React from 'react';
import { NavLink } from 'react-router-dom';
import { ClipboardCheck, History, ShieldCheck, Mail, Settings, Target } from 'lucide-react';

const mainNav = [
  { to: '/new-audit', icon: ClipboardCheck, label: 'New Audit',        testId: 'nav-new-audit' },
  { to: '/emails',    icon: Mail,           label: 'Gmail Inbox',      testId: 'nav-emails'    },
  { to: '/history',   icon: History,        label: 'Audit History',    testId: 'nav-history'   },
  { to: '/action-tracker', icon: Target,    label: 'Action Tracker',   testId: 'nav-action-tracker' },
];

const bottomNav = [
  { to: '/settings', icon: Settings, label: 'Settings', testId: 'nav-settings' },
];

export default function Sidebar({ onNavigate }) {
  return (
    <aside
      className="sidebar"
      data-testid="sidebar"
      style={{
        background: 'linear-gradient(180deg, #0f172a 0%, #1e293b 100%)',
        borderRight: 'none',
      }}
    >
      {/* Brand ─ distinctive logo area */}
      <div className="px-5 pt-7 pb-6">
        <div className="flex items-center gap-3">
          <div className="relative flex-shrink-0">
            <div
              className="w-9 h-9 rounded-xl flex items-center justify-center"
              style={{
                background: 'linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%)',
                boxShadow: '0 0 0 1px rgba(59,130,246,0.4), 0 4px 14px rgba(59,130,246,0.3)',
              }}
            >
              <ShieldCheck className="w-4.5 h-4.5 text-white" style={{ width: 18, height: 18 }} />
            </div>
            <span
              className="absolute -bottom-0.5 -right-0.5 w-2.5 h-2.5 rounded-full border-2"
              style={{ background: '#22c55e', borderColor: '#0f172a' }}
            />
          </div>
          <div>
            <p
              className="text-sm font-semibold text-white leading-tight"
              style={{ fontFamily: 'Space Grotesk', letterSpacing: '-0.01em' }}
            >
              Supply Chain
            </p>
            <p className="text-[11px] font-medium" style={{ color: '#64748b', fontFamily: 'Outfit' }}>
              AI Auditor · v2.1
            </p>
          </div>
        </div>

        <div className="mt-5 h-px" style={{ background: 'linear-gradient(90deg, transparent, rgba(148,163,184,0.15), transparent)' }} />
      </div>

      {/* Main Nav */}
      <nav className="px-3 flex-1">
        <p
          className="px-3 mb-2 text-[10px] font-semibold uppercase tracking-[0.12em]"
          style={{ color: '#475569', fontFamily: 'Outfit' }}
        >
          Navigation
        </p>
        {mainNav.map(({ to, icon: Icon, label, testId }) => (
          <NavLink
            key={to}
            to={to}
            data-testid={testId}
            onClick={onNavigate}
            className={({ isActive }) =>
              `nav-item ${isActive ? 'nav-item--active' : 'nav-item--idle'}`
            }
          >
            {({ isActive }) => (
              <>
                <div className={`nav-icon-wrap ${isActive ? 'nav-icon-wrap--active' : ''}`}>
                  <Icon style={{ width: 15, height: 15 }} />
                </div>
                <span className="nav-label">{label}</span>
                {isActive && <div className="nav-dot" />}
              </>
            )}
          </NavLink>
        ))}
      </nav>

      {/* Bottom ─ settings */}
      <div className="px-3 pb-5 pt-3">
        <div className="mb-3 h-px" style={{ background: 'linear-gradient(90deg, transparent, rgba(148,163,184,0.12), transparent)' }} />

        {bottomNav.map(({ to, icon: Icon, label, testId }) => (
          <NavLink
            key={to}
            to={to}
            data-testid={testId}
            onClick={onNavigate}
            className={({ isActive }) =>
              `nav-item ${isActive ? 'nav-item--active' : 'nav-item--idle'}`
            }
          >
            {({ isActive }) => (
              <>
                <div className={`nav-icon-wrap ${isActive ? 'nav-icon-wrap--active' : ''}`}>
                  <Icon style={{ width: 15, height: 15 }} />
                </div>
                <span className="nav-label">{label}</span>
                {isActive && <div className="nav-dot" />}
              </>
            )}
          </NavLink>
        ))}

        <div
          className="mt-4 mx-1 px-3 py-2.5 rounded-xl"
          style={{ background: 'rgba(255,255,255,0.04)', border: '1px solid rgba(255,255,255,0.06)' }}
        >
          <div className="flex items-center gap-2">
            <div
              className="w-5 h-5 rounded-md flex items-center justify-center flex-shrink-0"
              style={{ background: 'linear-gradient(135deg,#7c3aed,#4f46e5)' }}
            >
              <span style={{ fontSize: 9, fontWeight: 700, color: '#fff', fontFamily: 'Outfit' }}>λ</span>
            </div>
            <div>
              <p style={{ fontSize: 10, fontWeight: 600, color: '#94a3b8', fontFamily: 'Outfit' }}>
                Claude Sonnet 4.6
              </p>
              <p style={{ fontSize: 9, color: '#475569', fontFamily: 'Outfit' }}>Extended Thinking</p>
            </div>
          </div>
        </div>
      </div>
    </aside>
  );
}
